/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".supportBtn[_ngcontent-%COMP%]{background-color:var(--btn-bg-color3);color:var(--text-color6);text-transform:uppercase;font-size:18px;padding:5px 20px}\n/*# sourceMappingURL=faq.component.css.map*/"];
export { styles as styles };
